import React from "react";
import styled from "styled-components";
import { GAME_STATES } from "../../CoreLoop";
import BasicButton from "../BasicButton/BasicButton";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-size: 1.5rem;
  font-family: monospace;
  max-width: 25ch;
  margin: 0 auto;
  margin-top: 3rem;

  @media (min-width: 600px) {
    margin-top: 4rem;
  }

  opacity: var(--opacity);
  pointer-events: var(--pointer-events);
  transition: opacity 0.25s ease-in-out;
  grid-area: overlap;
`;

const IntroText = styled.p`
  font-size: 1.25rem;
  line-height: 1.25;
  @media (min-width: 600px) {
    font-size: 1.5rem;
  }
  font-family: monospace;
`;

const StartGameButtonWrapper = styled(BasicButton)`
  min-width: 15ch;
  margin-top: 1rem;
`;

function InitialInformation({ gameState, startGame }) {
  let text = "Readying Zucks";
  let opacity = 0;
  let pointerEvents = "none";
  let disabled = true;
  if (gameState === GAME_STATES.FIRST_PAGE_LOAD) {
    text = "Get Zucking";
    opacity = 1;
    pointerEvents = "auto";
    disabled = false;
  } else if (
    gameState === GAME_STATES.LOADING_LANDMARKERS ||
    gameState === GAME_STATES.LOADING_VIDEO
  ) {
    text = "Readying Zucks";
    opacity = 1;
  }

  return (
    <Wrapper
      style={{ "--opacity": opacity, "--pointer-events": pointerEvents }}
    >
      <IntroText>
        The secret to a perfect Zuck smile is his mouth and eyes. Focus on
        those.
      </IntroText>
      <IntroText>
        Remember to keep the right amount of life in your eyes!
      </IntroText>
      <IntroText>
        This site requires webcam access, but your face never leaves your
        computer.
      </IntroText>
      <StartGameButtonWrapper disabled={disabled} onClick={startGame}>
        {text}
      </StartGameButtonWrapper>
    </Wrapper>
  );
}

export default InitialInformation;
